import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { Stack } from '@mui/system';
import { DataGrid, GridColumns, GridRenderCellParams } from '@mui/x-data-grid';
import * as React from "react";
import { IVarDocumentHistoryEntryInDTO } from '../../repository/jago/model/input/IVarDocumentHistoryEntryInDTO';
import translations from '../../translations/i18next';

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column'
  },
  rowBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowTitle: {
    fontWeight: 'bold'
  },
  logo: {
    width: '20%',
  },
});


export interface IVarDocumentHistoryTableState {
}

export interface IVarDocumentHistoryTableProps extends WithStyles<typeof styles>{
  documentHistory: IVarDocumentHistoryEntryInDTO[];
  tableColumns?: GridColumns<IVarDocumentHistoryEntryInDTO>;
  onRowClick?: (documentHistory: IVarDocumentHistoryEntryInDTO) => void;
  rowHeight?: number;
  disableSelectionOnClick?: boolean;
  isLoading?: boolean;
}

class VarDocumentHistoryTable extends React.Component<IVarDocumentHistoryTableProps, IVarDocumentHistoryTableState> {
  private defaultColumns: GridColumns<IVarDocumentHistoryEntryInDTO>;
  public render() {
    const { documentHistory, disableSelectionOnClick, onRowClick, tableColumns, rowHeight } = this.props;
    this.defaultColumns = [
      {
        field: 'name',
        headerName: translations.t('gateways.name'),
        type: 'string',
        sortable: true,
        filterable: true,
        minWidth: 350,
        flex: 1,
        renderCell: (params: GridRenderCellParams<any>) => {
          return (<div></div>)}
      },
    ];

    return (
      <DataGrid
        getRowId={(d) => d.documentKey}
        rows={documentHistory || []}
        columns={tableColumns ? tableColumns: this.defaultColumns}
        rowHeight={rowHeight ? rowHeight: 55}
        onPageSizeChange={() => {}}
        onPageChange={() => {}}
        pageSize={100}
        loading={this.props.isLoading}
        onRowClick={row => onRowClick ? onRowClick(row.row) : null}
        paginationMode="server"
        disableSelectionOnClick={disableSelectionOnClick}
        hideFooterPagination={true}
        hideFooter={true}
        componentsProps={{}}
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
              </div>
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
            </Stack>
          )
        }}
        sx={{
          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
        }}
      />
    );
  }
}

export default withStyles(styles)(VarDocumentHistoryTable);